import { createAction, props } from "@ngrx/store";

export const FETCH_TRIAL_MASTER_LIST = createAction(
    'FETCHTRIALMASTERLIST',
    props<{ trials: any }>()
);